import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=36f9b4e0&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Home.vue?vue&type=style&index=1&id=36f9b4e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f9b4e0",
  null
  
)

export default component.exports